import { Component, OnInit, ViewChild } from '@angular/core';

import { MatPaginator, MatDialog, MatSort, MatTableDataSource } from '@angular/material';

import { ListaPreciosVentaTipo } from '../../models/ListaPreciosVentaTipo';
import { ListaPreciosVentaGeneral } from '../../models/ListaPreciosVentaGeneral';

import { modalConfirmationComponent } from '../../utils/modal/modal-confirmation.component';
import { generalService } from '../../services/general.service';

import { DatosGeneralesSAE } from '../../datos-generales-SAE';

import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-lista-precios',
  templateUrl: './lista-precios.component.html',
  styleUrls: ['./lista-precios.component.scss'],
  providers: [generalService]
})
export class ListaPreciosComponent implements OnInit {

	// ----------------------------------- DECLARACIÓN DE VARIABLES -----------------------------------
	public userData: any = JSON.parse(sessionStorage.getItem('user'));
	public datosGeneralesSAE: any;

	public tiposListaPrecios: ListaPreciosVentaTipo[] = [];
	public listasPreciosOriginal: ListaPreciosVentaGeneral[] = [];
	public listasPreciosParaMostrar: ListaPreciosVentaGeneral[] = [];
	public idListaPreciosDeshabilitar: string = "";
	public idFiltro: number;

	public parametroUrl:any;
	public consultaVentaCompra;
	public compra = false;
	public venta = false;

	dataSource = new MatTableDataSource<any>();
  	displayedColumns = ['acciones', 'nombre', 'tipoLista', 'destino', 'fechaInicioVigencia', 'fechaFinVigencia'];

  	@ViewChild(MatSort) sort: MatSort;
  	@ViewChild(MatPaginator) paginator: MatPaginator;

  	// ----------------------------------- DECLARACIÓN DE FUNCIONES -----------------------------------
	constructor(private _generalService: generalService, public dialog: MatDialog,public _activated : ActivatedRoute){ 
		this.datosGeneralesSAE = DatosGeneralesSAE;
		this._activated.params.forEach((params: Params)=>{
            this.parametroUrl = params['parametro'];
            console.log(this.parametroUrl);
          });
		this.cargarPantalla();
	}

	ngOnInit() {
		this.validarVentaCompra();
		
	}

	cargarPantalla(){
		this.datosGeneralesSAE.showSpinnerLoading = true;

		// 0 venta 
		// 1 compra
		this.parametroUrl == ':parametro' ? this.consultaVentaCompra = 1 : this.consultaVentaCompra = 0 ;
		
		this._generalService.requestGet("listaPrecios/cargarInformacionListado?idCompania=" + this.userData.COMPANY_ID +"&consultaVentaCompra="+this.consultaVentaCompra).subscribe(
			result => {
				var dataTemp: any = JSON.parse(result);

				this.tiposListaPrecios = dataTemp.Table;

				this.listasPreciosOriginal = dataTemp.Table1;
				this.listasPreciosParaMostrar = dataTemp.Table1;

				this.dataSource = new MatTableDataSource<any>(this.listasPreciosParaMostrar);
				this.dataSource.paginator = this.paginator;
				this.dataSource.sort = this.sort;

				this.datosGeneralesSAE.showSpinnerLoading = false;
			},
			error => {
			  var errorMsj = <any>error;
			  console.log(errorMsj);
			}
		);
	}

	consultarListasPreciosDisponibles(){
		this.listasPreciosOriginal = [];

		this._generalService.requestGet("listaPrecios/consultarListasPreciosDisponibles?idCompania=" + this.userData.COMPANY_ID).subscribe(
			result => {
				var dataTemp: any = JSON.parse(result);

				this.listasPreciosOriginal = dataTemp;
				this.listasPreciosParaMostrar = dataTemp;

				this.dataSource = new MatTableDataSource<any>(this.listasPreciosParaMostrar);
				this.dataSource.paginator = this.paginator;
				this.dataSource.sort = this.sort;

				this.datosGeneralesSAE.showSpinnerLoading = false;
			},
			error => {
			  var errorMsj = <any>error;
			  console.log(errorMsj);
			}
		);
	}

	filtrarListado(){
		let arr: any[];
		this.listasPreciosParaMostrar = [];
		arr = this.listasPreciosOriginal.filter(lp => 
			lp.SALES_PRICE_LIST_TYPE_ID == this.idFiltro
		);

		this.listasPreciosParaMostrar = arr;
		this.dataSource.data = this.listasPreciosParaMostrar;
	}

	limpiarFiltro(){
		this.idFiltro = 0;

		this.listasPreciosParaMostrar = this.listasPreciosOriginal;
		this.dataSource.data = this.listasPreciosParaMostrar;
	}

	confirmarDeshabilitarListaPrecios(idListaPrecios: string){
		this.idListaPreciosDeshabilitar = idListaPrecios;
		const dialogRef = this.dialog.open(modalConfirmationComponent, {
			disableClose: true,
			data: {
		        mensaje: "¿Está seguro de eliminar esta Lista de Precios?",
		    }
		});
	    
	    dialogRef.afterClosed().subscribe((result) => {
			if(result == 1){
				this.datosGeneralesSAE.showSpinnerLoading = true;
				this.deshabilitarListaPrecios();
			}
	  	});
	}

	deshabilitarListaPrecios(){
		this.datosGeneralesSAE.showSpinnerLoading = true;

		this._generalService.requestPut("listaPrecios/deshabilitarListaPrecios?idListaPrecios=" + this.idListaPreciosDeshabilitar).subscribe(
			result => {
				this.consultarListasPreciosDisponibles();
			},
			error => {
			  var errorMsj = <any>error;
			  console.log(errorMsj);
			}
		);
	}
	validarVentaCompra(){
      if( this.parametroUrl == ':parametro')
    	{
			this.compra = true;
			this.venta = false;
	    }
    	else
        {
			this.compra = false;
			this.venta = true;
                
        }     
    }

}



// WEBPACK FOOTER //
// ./src/app/lista-precios/lista-precios/lista-precios.component.ts